import request from "@/config/utils/request";
import { addUrlPerFix } from "@/basa/utils";
// 列表
// export function getListquery() {
//     return request({
//         url: "/apis/demo/listQuery",
//         method: "get"
//     });
// }
// 编辑
export function editUser(data) {
  return request({
    url: "/apis/ebs/userAndEducation/editUser",
    method: "POST",
    data
  });
}
// 添加
export function saveUser(data) {
  return request({
    url: "/apis/ebs/userAndEducation/saveUser",
    method: "POST",
    data
  });
}
// 删除
export function removeUser(data) {
  return request({
    url: "/apis/ebs/userAndEducation/removeUser", // 后端接口
    method: "post",
    data
  });
}
// 详情
export function getUserById(data) {
  return request({
    url: "/apis/ebs/userAndEducation/getUserById", // 后端接口
    method: "POST",
    data
  });
}
// 批量查询
export function getListbycheck(data) {
  return request({
    url: "/apis/ebs/user/listUserDemos",
    method: "POST",
    data
  });
}
// 列表所有信息
export function getpeoplemanageList(data) {
  return request({
    url: "/apis/ebs/userAndEducation/listUsers",
    method: "POST",
    data
  });
}
// 获取所有省
export function getAllprovince(data) {
  return request({
    url: "/apis/ebs/userAndEducation/listAddress",
    method: "POST",
    data
  });
}
// 部门
export function getdepartment(data) {
  return request({
    url:
      addUrlPerFix(process.env.VUE_APP_BASEP_URL) +
      "/apis/basap/basic/listDeptTreeFromOrg",
    method: "POST",
    data
  });
}
// 图片上传
export function uploadImg(data) {
  return request({
    url: this.$addUrlPerFix(process.env.VUE_APP_UPLOAD_URL),
    method: "POST",
    data
  });
}
//部门搜索
export function getdepartmentSearch(data) {
  return request({
    url: "/apis/ebs/userAndEducation/listSearch",
    method: "POST",
    data
  });
}
//详情用户信息
export function getAppUser(data) {
  return request({
    url: "/apis/ebs/user/getAppUser",
    method: "POST",
    data
  });
}
//应用访问权限变更
export function editAppUserState(data) {
  return request({
    url: "/apis/ebs/user/editAppUserState",
    method: "POST",
    data
  });
}
//apis/demo/role/qryRole 角色设置查询列表
export function qryRole(data) {
  return request({
    url: "/apis/ebs/role/qryRole",
    method: "POST",
    data
  });
}
// /apis/demo/role/delRole  按钮，打开/关闭
export function delRole(data) {
  return request({
    url: "/apis/ebs/role/delRole",
    method: "POST",
    data
  });
}
//添加兼职/添加部门接口：http://dev01-demo.iccec.cn/apis/demo/user/addUserPartyRelation
export function addUserPartyRelation(data) {
  return request({
    url: "/apis/ebs/user/addUserPartyRelation",
    method: "POST",
    data
  });
}
// 根据部门获取选中部门
export function getdepartmentById(data) {
  return request({
    url:
      addUrlPerFix(process.env.VUE_APP_BASEP_URL) +
      "/apis/basap/basic/listDeptFromDeptId",
    method: "POST",
    data
  });
}
